module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agentMessage":"Good morning, how can I help you?","customerMessage":"I am having problems with my pc"},"es":{"agentMessage":"Buenos días, ¿Cómo puedo ayuidarlo? ","customerMessage":"Tengo problemas con mi computador"}}')
  delete Component.options._Ctor
}
